import {
    OBTENER_PLATAFORMAS,
    AGREGAR_PLATAFORMA,
    ACTUALIZAR_PLATAFORMA,
    ELIMINAR_PLATAFORMA,
    PLATAFORMA_ERROR,
    OBTENER_PLATAFORMA_STATS
} from './plataformasActions';

const plataformasReducer = (state, action) => {
    switch (action.type) {
        case OBTENER_PLATAFORMAS:
            return {
                ...state,
                plataformas: action.payload
            };
        case AGREGAR_PLATAFORMA:
            return {
                ...state,
                plataformas: [...state.plataformas, action.payload]
            };
        case ACTUALIZAR_PLATAFORMA:
            return {
                ...state,
                plataformas: state.plataformas.map(plataforma =>
                    plataforma._id === action.payload._id ? action.payload : plataforma
                )
            };
        case ELIMINAR_PLATAFORMA:
            return {
                ...state,
                plataformas: state.plataformas.filter(plataforma => plataforma._id !== action.payload)
            };
        case PLATAFORMA_ERROR:
            return {
                ...state,
                mensaje: action.payload
            };
        case OBTENER_PLATAFORMA_STATS:
            return {
                ...state,
                stats: action.payload
            };
        default:
            return state;
    }
};

export default plataformasReducer;
